const tabsChecklistQuestions = {
  TabLabel1: 'DETALHAMENTO DA PERGUNTA',
  TabLabel2: 'IMAGEM DESCRITIVA',
  TabLabel3: 'OUTRAS OPÇÕES',
};

export default tabsChecklistQuestions;
